import { Col, Container, Row } from 'react-bootstrap'
import { LegalDoc } from 'src/@shared/types/cms/legalDoc'

import styles from './LegalDetail.module.scss'

export type legalDetailProps = {
    doc: LegalDoc
}

export default function LegalDetail({ doc }: legalDetailProps) {
    return (
        <section className="legalDetail">
            <Container fluid className={styles.containerBg}>
                <Container>
                    <Row>
                        <Col sm={{ span: 10, offset: 1 }} md={{ span: 8, offset: 2 }}>
                            <h2 className="mb-5">{doc.title}</h2>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container>
                <Row className="mt-8 pt-3">
                    <Col sm={{ span: 10, offset: 1 }} md={{ span: 8, offset: 2 }}>
                        <div className="body" dangerouslySetInnerHTML={{ __html: doc.body ?? '' }}></div>
                        <hr className="lineBodyEnd"></hr>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
